module.exports = __webpack_public_path__ + "img/cash-sync-color.146e6e42.svg";